import * as React from "react";
import type { SVGProps } from "react";
const SvgStethoscope = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 5c0 .55.45 1 1 1s1-.45 1-1c.55 0 1 .45 1 1v3.5c0 2.48-2.02 4.5-4.5 4.5S4 11.98 4 9.5V6c0-.55.45-1 1-1 0 .55.45 1 1 1s1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1C3.35 3 2 4.35 2 6v3.5c0 3.082 2.164 5.674 5.05 6.336C7.464 19.303 10.423 22 14 22c3.86 0 7-3.14 7-7v-2.172A3.012 3.012 0 0 0 23 10c0-1.65-1.35-3-3-3s-3 1.35-3 3c0 1.3.838 2.413 2 2.828V15a5.002 5.002 0 0 1-9.905.973C12.398 15.67 15 12.88 15 9.5V6c0-1.65-1.35-3-3-3 0-.55-.45-1-1-1s-1 .45-1 1v2Zm10 6c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStethoscope;
